import { SET_GOAL_TRANSACTIONS } from './actionTypes'

const initialState = { items: [] }

const items = (state = initialState, action) => {
  switch (action.type) {
    case SET_GOAL_TRANSACTIONS:
      return { ...state, items: action.items }
    default:
      return state
  }
}

export default items
